<div class="min-h-screen" [class.dark]="themeService.isDark()">
  <!-- Toast Notifications -->
  <p-toast position="top-right" [life]="3000"></p-toast>

  <!-- Auth0 Loading State -->
  <div *ngIf="isLoading()" class="fixed inset-0 flex items-center justify-center bg-jamaica-green-600 z-50">
    <div class="text-center">
      <img src="/logos/wsy-yardBull-Icon.png" alt="Wall St. Yardie Logo" class="h-16 w-16 mx-auto mb-4 animate-pulse" />
      <div class="text-white text-xl font-semibold">Loading...</div>
    </div>
  </div>

  <!-- Fixed Header - Matches Main Content Area Width -->
  <header *ngIf="!isAuthRoute()" class="fixed top-0 left-0 right-0 z-40 bg-background/90 backdrop-blur-lg text-foreground p-6 shadow-lg border-b border-border/30 transition-all duration-300 ease-in-out md:right-0"
          [class.md:left-64]="!desktopSidebarCollapsed()"
          [class.md:left-16]="desktopSidebarCollapsed()">
    <div class="flex items-center justify-between">
      <div class="flex items-center space-x-4">
        <!-- Mobile Sidebar Toggle -->
        <button
          (click)="toggleMobileSidebar()"
          class="md:hidden p-2 rounded-lg hover:bg-accent/80 transition-all duration-200 hover:scale-105"
        >
          <span class="text-2xl text-green-500"><i class="fas fa-bars"></i></span>
        </button>

        <!-- Desktop Page Header -->
        <div class="hidden md:block">
          <app-page-header></app-page-header>
        </div>
      </div>
      <div class="flex items-center space-x-3">
        <app-stock-search (appStockSelected)="onCompanySelected($event)"></app-stock-search>
        <!-- Desktop Profile & Theme Switcher -->
        <div class="hidden md:flex items-left space-x-2">
          <app-user-menu></app-user-menu>
        </div>
        <!-- Mobile Ellipsis Menu -->
        <div class="relative md:hidden">
          <button (click)="mobileMenuOpen = !mobileMenuOpen" class="p-2 rounded-lg hover:bg-accent/80 transition-all duration-200 hover:scale-105 shadow-sm border border-border/50" aria-label="Open menu">
            <i class="fa-solid fa-ellipsis-vertical text-xl"></i>
          </button>
          <div *ngIf="mobileMenuOpen" class="absolute right-0 mt-2 w-56 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-50 overflow-hidden">
            
            <!-- User Info Header -->
            @if (auth.user$ | async; as user) {
            <div class="px-4 py-3 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
              <div class="text-sm font-medium text-gray-900 dark:text-white truncate">
                <i class="fas fa-user mr-2 text-gray-500 dark:text-gray-400"></i>{{ user.name || user.email }}
              </div>
              <div class="mt-1.5">
                <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold capitalize"
                  [class.bg-gray-200]="currentPlan() === 'free'"
                  [class.text-gray-700]="currentPlan() === 'free'"
                  [class.bg-blue-100]="currentPlan() === 'standard'"
                  [class.text-blue-700]="currentPlan() === 'standard'"
                  [class.bg-yellow-100]="currentPlan() === 'pro'"
                  [class.text-yellow-700]="currentPlan() === 'pro'"
                  [class.bg-green-100]="currentPlan() === 'admin'"
                  [class.text-green-700]="currentPlan() === 'admin'">
                  <i class="fas fa-crown text-[10px]"></i>
                  {{ currentPlan() }} plan
                </span>
              </div>
            </div>
            }

            <ul class="py-2">
              <li>
                <button
                  [routerLink]="'/profile'"
                  (click)="mobileMenuOpen = false"
                  class="w-full text-left px-4 py-2 flex items-center space-x-3 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 transition-colors">
                  <i class="fas fa-cog text-lg w-5 text-center"></i>
                  <span>Account Settings</span>
                </button>
              </li>
              <li>
                <button (click)="toggleTheme(); mobileMenuOpen = false" class="w-full text-left px-4 py-2 flex items-center space-x-3 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 transition-colors">
                  <ng-container *ngIf="!themeService.isDark()">
                    <i class="fa-solid fa-moon text-lg w-5 text-center"></i> <span>Go Dark</span>
                  </ng-container>
                  <ng-container *ngIf="themeService.isDark()">
                    <i class="fa-solid fa-sun text-lg w-5 text-center"></i> <span>Go Light</span>
                  </ng-container>
                </button>
              </li>
              <li class="border-t border-gray-200 dark:border-gray-700 mt-1 pt-1">
                <button (click)="logout(); mobileMenuOpen = false" class="w-full text-left px-4 py-2 flex items-center space-x-3 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 transition-colors">
                  <i class="fas fa-sign-out-alt text-lg w-5 text-center"></i>
                  <span>Logout</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>

  <!-- Fixed Left Sidebar - Full Height with Collapse Support -->
  <aside *ngIf="!isAuthRoute()" class="fixed left-0 top-0 h-screen w-64 z-50 bg-gradient-to-b from-jamaica-green-500 to-jamaica-green-800 text-white shadow-lg flex flex-col justify-between transform -translate-x-full md:translate-x-0 transition-all duration-300 ease-in-out"
         [class.md:w-64]="!desktopSidebarCollapsed()"
         [class.md:w-16]="desktopSidebarCollapsed()"
         [class.translate-x-0]="mobileSidebarOpen">
    <div class="flex-1 overflow-y-auto">
      <!-- Logo & Title Section -->
      <div class="p-5 flex items-center space-x-4"
           [class.md:flex-col]="desktopSidebarCollapsed()"
           [class.md:justify-center]="desktopSidebarCollapsed()"
           [class.md:space-x-0]="desktopSidebarCollapsed()">
        <div class="relative">
          <img src="/logos/wsy-yardBull-Icon.png" alt="Wall St. Yardie Logo" class="h-8 w-8 drop-shadow-sm">
          <div class="absolute -inset-1 bg-jamaica-gold-400/20 rounded-full blur-sm -z-10"></div>
        </div>
        <h1 class="text-xl font-bold tracking-tight transition-opacity duration-300"
            [class.md:hidden]="desktopSidebarCollapsed()">
          Wall St. Yardie
        </h1>
      </div>

      <nav class="p-4 pt-5" [class.md:px-2]="desktopSidebarCollapsed()">
        <ul class="space-y-2">
          <li>
            <a
              [routerLink]="'/dashboard'"
              [class]="activeLink() === 'dashboard' ? 'flex items-center py-2 px-4 rounded bg-jamaica-gold-400 text-jamaica-black-800 font-semibold transition-colors' : 'flex items-center py-2 px-4 rounded hover:bg-jamaica-green-600 transition-colors'"
              [class.md:justify-center]="desktopSidebarCollapsed()"
              [attr.title]="desktopSidebarCollapsed() ? 'Dashboard' : null">
              <i class="fa-solid fa-home mr-3" [class.md:mr-0]="desktopSidebarCollapsed()"></i>
              <span class="transition-opacity duration-300" [class.md:hidden]="desktopSidebarCollapsed()">Dashboard</span>
            </a>
          </li>
          <li>
            <a
              appFeatureAccess="standard"
              featureName="yardie picks"
              [routerLink]="'/picks'"
              [class]="activeLink() === 'picks' ? 'flex items-center py-2 px-4 rounded bg-jamaica-gold-400 text-jamaica-black-800 font-semibold transition-colors' : 'flex items-center py-2 px-4 rounded hover:bg-jamaica-green-600 transition-colors'"
              [class.md:justify-center]="desktopSidebarCollapsed()"
              [attr.title]="desktopSidebarCollapsed() ? 'Yardie Picks' : null">
              <i class="fa-solid fa-star mr-3" [class.md:mr-0]="desktopSidebarCollapsed()"></i>
              <span class="transition-opacity duration-300 flex-1" [class.md:hidden]="desktopSidebarCollapsed()">Yardie Picks</span>
              <i *ngIf="!hasStandardAccess()" class="fa-solid fa-lock text-xs ml-auto opacity-70" [class.md:hidden]="desktopSidebarCollapsed()"></i>
            </a>
          </li>
          <li>
            <a
              appFeatureAccess="standard"
              featureName="watchlists"
              [routerLink]="'/watchlist'"
              [class]="activeLink() === 'watchlist' ? 'flex items-center py-2 px-4 rounded bg-jamaica-gold-400 text-jamaica-black-800 font-semibold transition-colors' : 'flex items-center py-2 px-4 rounded hover:bg-jamaica-green-600 transition-colors'"
              [class.md:justify-center]="desktopSidebarCollapsed()"
              [attr.title]="desktopSidebarCollapsed() ? 'Watchlists' : null">
              <i class="fa-solid fa-bookmark mr-3" [class.md:mr-0]="desktopSidebarCollapsed()"></i>
              <span class="transition-opacity duration-300 flex-1" [class.md:hidden]="desktopSidebarCollapsed()">Watchlists</span>
              <i *ngIf="!hasStandardAccess()" class="fa-solid fa-lock text-xs ml-auto opacity-70" [class.md:hidden]="desktopSidebarCollapsed()"></i>
            </a>
          </li>
          <li>
            <a
              appFeatureAccess="standard"
              featureName="stock screener"
              [routerLink]="'/screen'"
              [class]="activeLink() === 'screen' ? 'flex items-center py-2 px-4 rounded bg-jamaica-gold-400 text-jamaica-black-800 font-semibold transition-colors' : 'flex items-center py-2 px-4 rounded hover:bg-jamaica-green-600 transition-colors'"
              [class.md:justify-center]="desktopSidebarCollapsed()"
              [attr.title]="desktopSidebarCollapsed() ? 'Screener' : null">
              <i class="fa-solid fa-filter mr-3" [class.md:mr-0]="desktopSidebarCollapsed()"></i>
              <span class="transition-opacity duration-300 flex-1" [class.md:hidden]="desktopSidebarCollapsed()">Screener</span>
              <i *ngIf="!hasStandardAccess()" class="fa-solid fa-lock text-xs ml-auto opacity-70" [class.md:hidden]="desktopSidebarCollapsed()"></i>
            </a>
          </li>
          <li>
            <a
              [routerLink]="'/sectors'"
              [class]="activeLink() === 'sectors' ? 'flex items-center py-2 px-4 rounded bg-jamaica-gold-400 text-jamaica-black-800 font-semibold transition-colors' : 'flex items-center py-2 px-4 rounded hover:bg-jamaica-green-600 transition-colors'"
              [class.md:justify-center]="desktopSidebarCollapsed()"
              [attr.title]="desktopSidebarCollapsed() ? 'Sectors' : null">
              <i class="fa-solid fa-building mr-3" [class.md:mr-0]="desktopSidebarCollapsed()"></i>
              <span class="transition-opacity duration-300" [class.md:hidden]="desktopSidebarCollapsed()">Sectors</span>
            </a>
          </li>
          <li>
            <a
              appFeatureAccess="standard"
              featureName="congress trading disclosures"
              [routerLink]="'/congress'"
              [class]="activeLink() === 'congress' ? 'flex items-center py-2 px-4 rounded bg-jamaica-gold-400 text-jamaica-black-800 font-semibold transition-colors' : 'flex items-center py-2 px-4 rounded hover:bg-jamaica-green-600 transition-colors'"
              [class.md:justify-center]="desktopSidebarCollapsed()"
              [attr.title]="desktopSidebarCollapsed() ? 'Congress' : null">
              <i class="fa-solid fa-building-columns mr-3" [class.md:mr-0]="desktopSidebarCollapsed()"></i>
              <span class="transition-opacity duration-300 flex-1" [class.md:hidden]="desktopSidebarCollapsed()">Congress</span>
              <i
                *ngIf="!hasStandardAccess()"
                class="fa-solid fa-lock text-xs ml-auto opacity-70"
                [class.md:hidden]="desktopSidebarCollapsed()"
                aria-label="Locked feature"
                title="Locked feature">
              </i>
            </a>
          </li>
          <li>
            <a
              [routerLink]="'/tools'"
              [class]="activeLink() === 'tools' ? 'flex items-center py-2 px-4 rounded bg-jamaica-gold-400 text-jamaica-black-800 font-semibold transition-colors' : 'flex items-center py-2 px-4 rounded hover:bg-jamaica-green-600 transition-colors'"
              [class.md:justify-center]="desktopSidebarCollapsed()"
              [attr.title]="desktopSidebarCollapsed() ? 'Toolbox' : null">
              <i class="fa-solid fa-wrench mr-3" [class.md:mr-0]="desktopSidebarCollapsed()"></i>
              <span class="transition-opacity duration-300" [class.md:hidden]="desktopSidebarCollapsed()">Toolbox</span>
            </a>
          </li>
        </ul>
      </nav>

      <!-- Desktop Collapse Toggle Button (visible only on desktop) -->
      <div class="hidden md:flex py-2 px-4">
        <a
          (click)="toggleDesktopSidebar()"
          class="sidebar-toggle-btn"
          [attr.aria-label]="desktopSidebarCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'">
          <i
            class="fas transition-transform duration-300"
            [class.fa-chevron-right]="desktopSidebarCollapsed()"
            [class.fa-chevron-left]="!desktopSidebarCollapsed()">
          </i>
        </a>
      </div>
    </div>

    <!-- Bottom Section: Social Links & Disclaimers (hidden on desktop when collapsed, always visible on mobile) -->
    <div class="p-4 border-t border-white/20 transition-opacity duration-300"
         [class.md:hidden]="desktopSidebarCollapsed()">
      <!-- Social Media Links -->
      <div class="flex justify-left space-x-4 mb-4 ">
          <a
            href="{{ socialLinks.facebook }}"
            target="_blank"
            rel="noopener noreferrer"
            class="social-icon hover:text-jamaica-gold-400 transition-colors duration-200"
            aria-label="Follow us on Facebook"
          >
            <i class="fa-brands fa-square-facebook text-2xl"></i>
          </a>
          <a
            href="{{ socialLinks.twitter }}"
            target="_blank"
            rel="noopener noreferrer"
            class="social-icon hover:text-jamaica-gold-400 transition-colors duration-200"
            aria-label="Follow us on Twitter"
          >
            <i class="fa-brands fa-square-twitter text-2xl"></i>
          </a>
          <a
            href="{{ socialLinks.instagram }}"
            target="_blank"
            rel="noopener noreferrer"
            class="social-icon hover:text-jamaica-gold-400 transition-colors duration-200"
            aria-label="Follow us on Instagram"
          >
            <i class="fa-brands fa-square-instagram text-2xl"></i>
          </a>
          <a
            href="{{ socialLinks.youtube }}"
            target="_blank"
            rel="noopener noreferrer"
            class="social-icon hover:text-jamaica-gold-400 transition-colors duration-200"
            aria-label="Subscribe to our YouTube channel"
          >
            <i class="fa-brands fa-square-youtube text-2xl"></i>
          </a>
          <!-- <a href="{{ socialLinks.podcast }}" target="_blank" rel="noopener noreferrer"
             class="social-icon"
             aria-label="Listen to our podcast">
            <i class="fas fa-microphone text-2xl"></i>
          </a> -->
        </div>
      <div class="text-sm text-center">
        <a [routerLink]="'/disclaimer'" class="hover:text-jamaica-gold-400 transition-colors duration-200">Disclaimer</a> •
        <a [routerLink]="'/terms'" class="hover:text-jamaica-gold-400 transition-colors duration-200">Terms</a> •
        <a [routerLink]="'/privacy'" class="hover:text-jamaica-gold-400 transition-colors duration-200">Privacy</a> •
        <a [routerLink]="'/do-not-sell'" class="hover:text-jamaica-gold-400 transition-colors duration-200">Do Not Sell</a> •
        <a [routerLink]="'/refund'" class="hover:text-jamaica-gold-400 transition-colors duration-200">Refund</a> •
        <a [routerLink]="'/cookies'" class="hover:text-jamaica-gold-400 transition-colors duration-200">Cookies</a>
      </div>
      <div class="text-xs text-white/70 text-left mt-4">
         <p class="leading-relaxed">
          <strong>Disclaimer:</strong> All company names, logos, and brands used
          are the property of their respective owners.
        </p>
        <!-- Their appearance does not imply any affiliation with or endorsement by these companies. -->
      </div>
      <div class="text-xs text-white/70 text-center mt-4">

        <p>&copy; 2024-{{currentYear}} Wall St. Yardie Inc. <br/> All rights reserved.</p>
      </div>
    </div>
  </aside>

  <!-- Mobile Sidebar Overlay -->
  <div
    *ngIf="mobileSidebarOpen"
    class="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
    (click)="closeMobileSidebar()"
  ></div>

  <!-- Main Content Area - Only This Scrolls -->
  <main id="main-scroll"
        [class]="isAuthRoute() ? 'fixed top-0 left-0 right-0 bottom-0 overflow-y-auto bg-background text-foreground' : 'fixed top-16 left-0 right-0 bottom-0 overflow-y-auto bg-background text-foreground md:right-0 transition-all duration-300 ease-in-out'"
        [class.md:left-64]="!isAuthRoute() && !desktopSidebarCollapsed()"
        [class.md:left-16]="!isAuthRoute() && desktopSidebarCollapsed()"
        style="background: radial-gradient(circle at 30% 20%, hsl(var(--muted) / 0.15) 0%, transparent 50%), radial-gradient(circle at 70% 80%, hsl(var(--muted) / 0.1) 0%, transparent 50%), hsl(var(--background));">
    <div [class]="isAuthRoute() ? '' : 'my-5 mx-2 md:mx-5 p-0 md:p-4'">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
